import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import {
  createProductLine,
  CreateProductLineDto,
} from "#modules/productLines/infra/createProductLine.api";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";

export const useCreateProductLine = ({
  quoteRequestLineId,
  options,
}: {
  quoteRequestLineId: string;
  options?: {
    onSuccess?: () => void;
    onError?: (err: Error) => void;
  };
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: (payload: CreateProductLineDto) =>
      createProductLine({ id: quoteRequestLineId, payload }),

    onSuccess: async () => {
      await queryClient.invalidateQueries(quoteRequestLineQuery({ id: quoteRequestLineId }));

      options?.onSuccess?.();
    },

    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { createProductLine: mutate, ...rest };
};
